import { render, staticRenderFns } from "./ExercisesTable.vue?vue&type=template&id=fdfc80e0&scoped=true&"
import script from "./exercisestable.js?vue&type=script&lang=js&"
export * from "./exercisestable.js?vue&type=script&lang=js&"
import style0 from "./ExercisesTable.vue?vue&type=style&index=0&id=fdfc80e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfc80e0",
  null
  
)

export default component.exports